import { AuthenticatedInterface, Interface } from "./Interface";

export { Interface, AuthenticatedInterface };
export default Interface;
